import styled from 'styled-components'

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 26px;
  line-height: 20px;
  margin: 0 6px;

  text-align: center;
  font-size: 14px;
  font-weight: 700;

  background-color: ${({ theme }) => theme['-ds-core-400'].value};
  border-radius: 100px;
  color: white;
`

export default Badge
